import { render, staticRenderFns } from "./AffinityCategories.vue?vue&type=template&id=638189e0"
import script from "./AffinityCategories.vue?vue&type=script&lang=js"
export * from "./AffinityCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports